import API from '@/org-app/api';
import { createDeleteAction, createGetAllAction, createGetOneAction } from '@/utils/ActionsUtils';

import * as types from './mutation-types';

const actions = {
  getReportExecutions: createGetAllAction(
    API.instance.getReportExecutions,
    types.UPDATE_REPORTEXECUTIONS_LIST,
    'messages.failedToGetReportExecutions',
    true,
  ),
  getReportExecution: createGetOneAction(
    API.instance.getReportExecution,
    types.UPDATE_REPORTEXECUTION,
    'messages.failedToGetReportExecution',
  ),
  deleteReportExecution: createDeleteAction(
    API.instance.deleteReportExecution,
    types.DELETE_REPORTEXECUTION,
    'messages.failedToDeleteReportExecution',
  ),
};

export default actions;
